export const breakpoints = {
  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },
  },
  computed: {
    breakpoints() {
      const currentWidth = parseInt(this.windowWidth);
      return {
        xs: currentWidth < 576,
        sm: currentWidth < 768,
        md: currentWidth < 992,
        lg: currentWidth < 1200,
        xlg: currentWidth < 1400,
        exlg: currentWidth > 1400,
      };
    },
    customBreakPoints() {
      const currentWidth = parseInt(this.windowWidth);
      return {
        tabletMode: currentWidth < 830,
      };
    },
  },
};
